
import { Vue } from 'vue-class-component';
import { EmailAuthProvider, GoogleAuthProvider } from '@firebase/auth';

export default class LoginBox extends Vue {
  mounted() {
    const ui = this.$authUi;

    const uiConfig = {
      signInSuccessUrl: '/profile',
      signInOptions: [
        EmailAuthProvider.PROVIDER_ID,
        GoogleAuthProvider.PROVIDER_ID,
      ],
    };
    ui.start('#firebaseui-auth-container', uiConfig);
  }
}
